<vs-dialog [config]="{ dialogContainerClass: 'w-[350px] sm:w-[550px] max-w-[600px]' }" (closed)="onClosed()">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      showDivider: true,
      hideCloseButton: paying,

      icon: receipt ? 'check-circle' : 'credit-card-02',
      iconTheme: receipt ? 'success' : 'primary',

      title: receipt ? 'Payment complete' : 'Pay batch',
      subtitle: receipt
        ? 'These warranties are being funded and will move out of this list.'
        : 'Confirm the total, enter the billing address and choose how to pay.'
    }"
  ></vs-dialog-header>

  <!-- Confirmation -->
  <div *ngIf="receipt as receipt; else payForm" class="px-2 pt-4 flex flex-col gap-4">
    <div class="rounded-xl border border-gray-200 bg-base shadow-sm overflow-hidden">
      <div class="flex items-center gap-2 px-4 py-3 border-b border-gray-200 bg-gray-50">
        <vs-icon name="receipt-check" size="16" class="text-success-700"></vs-icon>
        <span class="text-sm font-semibold text-gray-900">Payment receipt</span>
      </div>

      <div class="flex flex-col gap-2 px-4 py-3 text-sm">
        <div class="flex justify-between gap-4">
          <span class="text-gray-600">Warranties funded</span>
          <span class="font-medium text-gray-900">{{ warrantyCount }}</span>
        </div>
        <div class="flex justify-between gap-4">
          <span class="text-gray-600 shrink-0">Transaction reference</span>
          <span class="font-medium text-gray-900 break-all text-right">{{ receipt.transactionReference ?? '—' }}</span>
        </div>
      </div>

      <div class="flex items-end justify-between gap-4 px-4 py-3 border-t border-gray-200 bg-gray-50">
        <span class="text-sm font-medium text-gray-700">Amount paid</span>
        <span class="text-2xl font-semibold leading-none text-gray-900">
          {{ receipt.amount / 100 | currency: 'USD' : 'symbol' : '1.2-2' }}
        </span>
      </div>
    </div>

    <div
      class="sticky bottom-0 z-10 -mx-2 -mb-1 px-2 pt-3 pb-3 bg-base border-t border-gray-200 flex items-center justify-end"
    >
      <button vs-button theme="primary" class="min-w-[120px] justify-center" (click)="done()">Done</button>
    </div>
  </div>

  <!-- Payment form -->
  <ng-template #payForm>
    <!-- vs-dialog already scrolls its projected content with a themed scrollbar, so no inner scroll box. -->
    <form [formGroup]="form" class="px-2 pt-4 flex flex-col gap-4">
      <!-- No line items: the rows are already listed and ticked in the table behind this dialog. -->
      <div class="rounded-xl border border-gray-200 bg-gray-50 shadow-sm overflow-hidden">
        <div class="flex items-center gap-2 px-4 py-3 border-b border-gray-200">
          <vs-icon name="receipt" size="16" class="text-primary-500"></vs-icon>
          <span class="text-sm font-semibold text-gray-900">Batch summary</span>

          <vs-badge class="ml-auto">
            {{ warrantyCount }} {{ warrantyCount === 1 ? 'warranty' : 'warranties' }}
          </vs-badge>
        </div>

        <div class="flex items-end justify-between gap-4 px-4 py-3">
          <span class="text-sm font-medium text-gray-700">Total due</span>
          <span class="text-2xl font-semibold leading-none text-gray-900">
            {{ amount / 100 | currency: 'USD' : 'symbol' : '1.2-2' }}
          </span>
        </div>
      </div>

      <vs-form-field [config]="{ label: 'Billing address' }">
        <!--
          Layout-only overrides so the address fits in four rows instead of six: City pairs with Zip and
          Country pairs with State. The address component's own field order is line1, line2, city, country,
          zip, state — nth-of-type follows that order, so it needs revisiting if those fields are reordered.
        -->
        <vs-address-input
          class="block [&>form]:max-w-none [&>form]:gap-2 [&_vs-form-field:nth-of-type(3)]:col-span-1 [&_vs-form-field:nth-of-type(3)]:order-1 [&_vs-form-field:nth-of-type(5)]:order-2 [&_vs-form-field:nth-of-type(4)]:col-span-1 [&_vs-form-field:nth-of-type(4)]:order-3 [&_vs-form-field:nth-of-type(6)]:order-4"
          formControlName="billingAddress"
        ></vs-address-input>
      </vs-form-field>

      <!-- Covers saved methods, new cards and bank accounts. `address` powers its "Use my home address" checkbox. -->
      <p *ngIf="loadingGateway" class="text-sm text-gray-600">Checking payment gateway...</p>
      <p *ngIf="gatewayError" class="text-sm text-danger">{{ gatewayError }}</p>
      <vs-select-or-create-payment-method
        *ngIf="gatewayInstanceId && !loadingGateway"
        #input
        [gatewayInstanceId]="gatewayInstanceId"
        [address]="form.value.billingAddress ?? null"
        [userId]="(currentUser$ | async)?.id ?? null"
        formControlName="paymentMethodId"
      ></vs-select-or-create-payment-method>

      <!-- Hidden while a card or bank form is open — those steps carry their own buttons. -->
      <div
        *ngIf="gatewayInstanceId && !loadingGateway && paymentInput?._state === 'select'"
        class="sticky bottom-0 z-10 -mx-2 -mb-1 px-2 pt-3 pb-3 bg-base border-t border-gray-200 flex items-center justify-end gap-3"
      >
        <button vs-button appearance="outline" [disabled]="paying" (click)="close()">Back</button>
        <button
          vs-button
          theme="primary"
          class="min-w-[160px] justify-center"
          [disabled]="form.invalid || paying"
          (click)="pay()"
        >
          {{ paying ? 'Paying…' : 'Pay ' + (amount / 100 | currency) }}
        </button>
      </div>
    </form>
  </ng-template>
</vs-dialog>
